import { type ApiResponse } from "../types/api/ApiResponse";
import { type AddressApiResponse } from "../types/api/AddressApi";
import { ApiRequest } from "./base";

const apiRoute = "address";

export const AddressApi = {
	async LookupPostcode(postcode, signal = null): Promise<ApiResponse<AddressApiResponse>> {
		const { addresses } = await ApiRequest(`${apiRoute}/postcode-lookup`, "POST", { postcode, signal });
		return addresses;
	},
	async LookupAddress(address, signal = null) {
		const { addresses } = await ApiRequest(`${apiRoute}/lookup/${address}`, "GET", { signal });
		return addresses;
	},
	async ValidateAddress(id, signal = null) {
		const { address } = await ApiRequest(`${apiRoute}/validate/${id}`, "GET", { signal });
		return address;
	},
};
